// Regional default syllabi (backend controller/defaultSyllabus.js, admin only).
import { serviceConsumer } from '../../network/ServiceConsumer';

const BASE = () => `${process.env.REACT_APP_BASE_URL}/api/admin/default-syllabi`;

export const getRegions = () => serviceConsumer('GET', `${BASE()}/regions`);
export const getRegionRows = (region) => serviceConsumer('GET', BASE(), { region });
export const createRow = (region, row) => serviceConsumer('POST', BASE(), { region, ...row });
export const updateRow = (id, row) => serviceConsumer('PUT', `${BASE()}/${id}`, row);
export const deleteRow = (id) => serviceConsumer('DELETE', `${BASE()}/${id}`);
